import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, isRef as _isRef, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-caea7114"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M14.5,4H1.5c-.28,0-.5-.22-.5-.5s.22-.5,.5-.5H14.5c.28,0,.5,.22,.5,.5s-.22,.5-.5,.5Z",
    fill: "currentColor"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M11.02,3.81l-.44-1.46c-.06-.21-.26-.36-.48-.36H5.9c-.22,0-.41,.14-.48,.36l-.44,1.46-.96-.29,.44-1.46c.19-.64,.77-1.07,1.44-1.07h4.2c.67,0,1.24,.43,1.44,1.07l.44,1.46-.96,.29Z",
    fill: "currentColor"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M11.53,15H4.47c-.81,0-1.47-.64-1.5-1.45l-.34-9.87,1-.03,.34,9.87c0,.27,.23,.48,.5,.48h7.07c.27,0,.49-.21,.5-.48l.34-9.87,1,.03-.34,9.87c-.03,.81-.69,1.45-1.5,1.45Z",
    fill: "currentColor"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M6.5,11.62c-.28,0-.5-.22-.5-.5V7.12c0-.28,.22-.5,.5-.5s.5,.22,.5,.5v4c0,.28-.22,.5-.5,.5Z",
    fill: "currentColor"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M9.5,11.62c-.28,0-.5-.22-.5-.5V7.12c0-.28,.22-.5,.5-.5s.5,.22,.5,.5v4c0,.28-.22,.5-.5,.5Z",
    fill: "currentColor"
  })
], -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "d-flex align-items-top justify-content-between relative" }
const _hoisted_5 = { class: "d-flex my-2 position-relative" }
const _hoisted_6 = { class: "titleInputContainer" }

import { reactive, ref, Ref } from "vue";
import ProductDescriptionFormCollectionItem from "./ProductDescriptionFormCollectionItem.vue";
import { ProductDescription } from "@/models/product/description/ProductDescription";
import ApiService from "@/_services/api.service"
import CustomWysiwyg from "../../forms/input/CustomWysiwyg.vue";
import { createInput } from '@formkit/vue'
import swal from "@/_helpers/swal";
import { useI18n } from "vue-i18n";


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductDescriptionFormCollection',
  props: {
  descriptions: {
    type: Object as () => ProductDescription[],
    required: true,
  },
  isDisabled: { type: Boolean, default: false },
},
  setup(__props, { expose: __expose }) {

const props = __props;

const { t } = useI18n();



__expose({
  submitProductDescriptions,
});

let productDescriptions = reactive(props.descriptions);
const wysiwyg = createInput(CustomWysiwyg)
let wysiwygReady = ref(false) ;

const baseDescription = {
  name: "Description",
  content: "",
  images: [],
  position: 1,
  products: [],
  uuid: "",
};

setTimeout(() => {
  wysiwygReady.value =true ;
}, 5000);


function checkDeleteDescription(descriptionIndex: number) {
  swal
    .confirm("Êtes-vous sûr de vouloir supprimer cette description ?")
    .then((result) => {
      if (result.isConfirmed) {
        removeDescription(descriptionIndex);
      }
    });
}

function addDescription() {
  productDescriptions.push(baseDescription);
}

function removeDescription(descriptionIndex: number): void {
  const descriptionToRemove = productDescriptions.splice(
    descriptionIndex,
    1
  )[0];

  if (descriptionToRemove.uuid) {
    deleteProductDescription(descriptionToRemove.uuid);
  }
}

const deleteProductDescription = async (uuid: string) => {
  await ApiService.delete("product_descriptions/" + uuid)
    .then(() => {
      swal.info("Cette description a bien été supprimée.");
    })
    .catch(() => {
      swal.error("Une erreur est survenu.");
      return false;
    });
};

async function submitProductDescriptions() {
  const descriptionsUuid: Array<string> = [];
  let descriptionsSaved = 0;

  if(productDescriptions.length > 5) return;

  for (let i = 0; i < productDescriptions.length; i++) {
    let description = productDescriptions[i];
    
    if (!description.name || !description.content) continue;

    checkDescriptionImages(description);
    description.position = i + 1;
    description.uuid = description.uuid ?? '';
    try {
      let apiAction = description.uuid
        ? await ApiService.patch("product_descriptions", description.uuid, description)
        : await ApiService.post("product_descriptions", description);

      const data = apiAction.data.data;
      description.uuid = data.uuid;
      descriptionsUuid.push(data.uuid);
      descriptionsSaved += 1;
    } catch (error) {
      swal.error('Une erreur est survenu.');
    }
  }

  if (!descriptionsSaved) {
    swal.error('Aucune description n\'a été enregistrées');
  } else {
    swal.info(`${descriptionsSaved} ${t('ProductForm.ImageDescriptionBloc.description', descriptionsSaved)} ${t('Actions.save.feminine', descriptionsSaved)}.`);
  }

  return descriptionsUuid;
}

function checkDescriptionImages(description) {
  const descriptionImages = [];
  description.images?.forEach((image, index) => {
    const isImageDeleted = !description.content.includes(image.url);

    if (isImageDeleted) {
      return;
    }
    descriptionImages.push(`/api/images/${image.uuid}`);
  });
  description.images = descriptionImages;
}

return (_ctx: any,_cache: any) => {
  const _component_FormKit = _resolveComponent("FormKit")!

  return (_openBlock(), _createBlock(_component_FormKit, {
    id: "repeater",
    name: "descriptions",
    type: "repeater",
    "add-label": "Ajouter une description",
    modelValue: _unref(productDescriptions),
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(productDescriptions) ? (productDescriptions).value = $event : productDescriptions = $event)),
    validation: "min:1|max:5",
    downControl: false,
    upControl: false,
    "validation-messages": {
      min: 'Vous devez avoir au moins 1 description.',
      max: 'Vous ne pouvez pas avoir plus de 5 descriptions.'
    },
    "validation-visibility": "live",
    disabled: __props.isDisabled
  }, {
    removeControl: _withCtx(({ index }) => [
      (index != 0 || _unref(productDescriptions).length > 1)
        ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            onClick: ($event: any) => (checkDeleteDescription(index)),
            class: "cursor-pointer formkit-remove-icon block w-5 my-1 formkit-icon"
          }, _hoisted_3, 8, _hoisted_1))
        : _createCommentVNode("", true)
    ]),
    default: _withCtx(({ index }) => [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_FormKit, {
              type: "text",
              label: "Titre de la description",
              validation: "length:0,50",
              "validation-messages": {
              length: 'Ce champ doit contenir maximum 50 caractères.',
            },
              placeholder: "Titre de la description",
              name: "name",
              value: "Description"
            }, null, 8, ["validation-messages"])
          ])
        ])
      ]),
      (_unref(wysiwygReady))
        ? (_openBlock(), _createBlock(_component_FormKit, {
            key: 0,
            type: _unref(wysiwyg),
            label: "Contenu",
            name: "content",
            content: _unref(productDescriptions)[index]?.content
          }, null, 8, ["type", "content"]))
        : _createCommentVNode("", true),
      _createVNode(_component_FormKit, {
        type: "hidden",
        name: "position"
      }),
      _createVNode(_component_FormKit, {
        type: "hidden",
        name: "uuid"
      })
    ]),
    _: 1
  }, 8, ["modelValue", "validation-messages", "disabled"]))
}
}

})